import { render, staticRenderFns } from "./DashboardDetailSPM.vue?vue&type=template&id=20ccfbf6&"
import script from "./DashboardDetailSPM.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailSPM.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDetailSPM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports